<template>
  <!-- :style="{'min-height': docHt + 'px'}" -->
   <div class="wrapper">
     <div class="container">
       <!-- <div class="input-group">
         <h5>微信号（企业、个体用户必须使用法人微信号）</h5>
         <el-input v-model="form.shopLicenseName" maxlength="20" @input="form.shopLicenseName = trimSpecial(form.shopLicenseName)"></el-input>
       </div> -->
       <!-- <div class="input-group">
         <h5>小程序名称</h5>
         <el-input v-model="form.name" maxlength="20" @input="form.name = trimSpecial(form.name)"></el-input>
       </div> -->
       <div class="input-group">
         <h5>APPID</h5>
         <el-input v-model="form.appId" maxlength="30" @input="form.appId = trimSpecial(form.appId)"></el-input>
         <!-- <div class="app-id-box">
           <el-input class="input-app-id" v-model="form.appId" maxlength="30" @input="form.appId = trimSpecial(form.appId)"></el-input>
           <div class="btn">获取APPID</div>
         </div> -->
       </div>
       <div class="input-group">
         <h5>原始ID</h5>
         <el-input v-model="form.originalId" maxlength="30" @input="form.originalId = trimSpecial(form.originalId)"></el-input>
       </div>
       <div class="input-group">
         <h5>APPID密钥</h5>
         <el-input v-model="form.keyWord" maxlength="50" @input="form.keyWord = trimSpecial(form.keyWord)"></el-input>
       </div>
 
       <!-- <div class="input-group input-group-category">
         <div class="col">
           <h5>所属行业大类</h5>
           <el-select v-model="form.categoryValue" placeholder="请选择">
             <el-option
               v-for="item in categoryOptions"
               :key="item.value"
               :label="item.label"
               :value="item.value">
             </el-option>
           </el-select>
         </div>
         <div class="col">
           <h5>所属行业子类</h5>
           <el-select v-model="form.propertyValue" placeholder="请选择">
             <el-option
               v-for="item in propertyOptions"
               :key="item.value"
               :label="item.label"
               :value="item.value">
             </el-option>
           </el-select>
         </div>
       </div> -->
       <!-- <div class="input-group">
         <h5>简介</h5>
         <el-input type="textarea" v-model="form.desc" resize="none" maxlength="200" :rows="4" @input="form.desc = trimSpecial(form.desc)"></el-input>
       </div>
       <div class="section">
         <h5>小程序头像</h5>
         <VantUploadImg :shopCode="shopCode" :value="images" :limit="1" :isInApp="true" @valChange="getImages" class="avatar" />
       </div> -->
     </div>
     <div class="footer-bar"></div>
     <div class="footer footer-btns">
       <div class="submit-btn" @click="submit">提交</div>
       <router-link :to="{path: '/auth-succes?shopCode='+shopCode}" class="jump-btn">跳过</router-link>
     </div>
   </div>
 </template>
 
 <script>
 import VantUploadImg from '@/components/VantUploadImg.vue';
 import { settingAppId, wxGetCategory} from '@/api/register';
 export default {
   components: {
     VantUploadImg: VantUploadImg,
   },
   data () {
     return {
       docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
       shopCode: null,
       categoryOptions: [],
       propertyOptions: [],
       images: '',
       form: {
         name: '',
         appId: '',
         originalId: '',
         keyWord: '',
         desc: '',
         avatar: ''
       }
     }
   },
   created() {
     let form = sessionStorage.getItem('registerMpForm');
     if(form) {
       this.form = {
         appId: form.appId,
         originalId: form.originalId,
         keyWord: form.keyWord,
        //  name: form.name,
        //  desc: form.desc,
        //  avatar: form.avatar
       }
       this.images = form.avatar;
     }
     if(this.$route.query){
       this.shopCode = this.$route.query.shopCode;
     }
     // this.wxGetCategory();
   },
   methods: {
     wxGetCategory() {
       wxGetCategory({shopCode: this.shopCode}).then(res => {
         this.categoryOptions = res.data;
       })
     },
     getImages(files) {
       this.form.avatar = files;
       this.images = files;
     },
     submit() {
       if(this.form.appId===''||this.form.originalId===''||this.form.keyWord==='') return this.Toast('APPID、原始ID、APPID密钥信息不可为空~');
       let params = {
         "appSecret": this.form.keyWord,
         "appletsId": this.form.appId,
         "originalId": this.form.originalId,
        //  "appletsDesc": this.form.desc,
        //  "appletsImage": this.form.avatar,
        //  "appletsName": this.form.name,
         "shopCode": this.shopCode
       }
       sessionStorage.setItem('registerMpForm', JSON.stringify(params));
       settingAppId(params).then(res => {
         if(res.code === 200) {
           setTimeout(() => {
             this.$router.push({
              path: '/auth-succes?shopCode=' + this.shopCode
             })
           }, 1500)
         } else {
           this.Toast(res.msg);
         }
       })
     }
   }
 }
 </script>
 
 <style lang="scss" scoped>
 @media screen and (max-width:750px){
   .input-group{
     &:first-child{
       margin-top: 1.5rem;
     }
   }
   .input-group, .section{
     width: 16.7rem;
     margin: 0 auto 1.2rem;
     h5{
       margin-bottom: .4rem;
       font-size: .7rem;
       color: #666;
       font-weight: 400;
     }
     /deep/ .el-input__inner, /deep/ .el-textarea__inner{
       border-radius: .5rem;
       border: 1px solid #ddd;
       font-size: .8rem;
       color: #222;
     }
     /deep/ .el-textarea__inner{
       padding: .3rem .5rem;
     }
     /deep/ .el-input__inner::-webkit-input-placeholder, /deep/ .el-textarea__inner::-webkit-input-placeholder{
       font-size: .8rem;
     }
     /deep/ .el-input__inner{
       height: 2.4rem;
       padding: 0 .5rem;
     }
   }
   .avatar{
     background: #f5f5f9;
   }
   .input-group-category{
     display: flex;
     justify-content: space-between;
     .col{
       width: 8.1rem;
     }
   }
   .app-id-box{
     width: 100%;
     display: flex;
     cursor: pointer;
     .input-app-id{
       width: 12.3rem;
       height: 2.4rem;
       border-radius: .5rem 0 0 .5rem;
       border: 1px solid #ddd;
       position: relative;
       @include flex(space-between);
       @include text-overflow();
       /deep/ .el-input__inner{
         border: 0;
       }
     }
     .btn{
         width: 4.4rem;
         height: 2.4rem;
         border-radius: 0 .5rem .5rem 0;
         border: 1px solid #ddd;
         border-left: 0;
         @include flex();
         font-size: .7rem;
         color: #47B6C7;
       }
   }
   .submit-btn{
     width: 8.1rem;
     height: 2.2rem;
     line-height: 2.15rem;
     background: #47B6C7;
     border-radius: .5rem;
     font-size: .8rem;
     color: #fff;
     text-align: center;
     margin: 0;
     // margin: 2.1rem auto 1.5rem;
   }
   .jump-btn{
     line-height: 1.4;
     font-size: .8rem;
     color: #47B6C7;
     text-align: center;
     display: block;
     margin-left: .6rem;
   }
   .footer{
     box-shadow: 0px -5px 5px #eee;
   }
 }
 @media screen and (min-width:750px){
   .container{
     height: 70vh;
   }
   .input-group{
     &:first-child{
       margin-top: 30px;
     }
   }
   .input-group, .section{
     width: 334px;
     margin: 0 auto 24px;
     h5{
       margin-bottom: 8px;
       font-size: 14px;
       color: #666;
       font-weight: 400;
     }
     /deep/ .el-input__inner, /deep/ .el-textarea__inner{
       border-radius: 10px;
       border: 1px solid #ddd;
       font-size: 16px;
       color: #222;
     }
     /deep/ .el-textarea__inner{
       padding: 6px 10px;
     }
     /deep/ .el-input__inner::-webkit-input-placeholder, /deep/ .el-textarea__inner::-webkit-input-placeholder{
       font-size: 16px;
     }
     /deep/ .el-input__inner{
       height: 48px;
       padding: 0 10px;
     }
   }
   .input-group-category{
     display: flex;
     justify-content: space-between;
     .col{
       width: 162px;
     }
   }
   .app-id-box{
     width: 100%;
     display: flex;
     cursor: pointer;
     .input-app-id{
       width: 246px;
       height: 48px;
       border-radius: 10px 0 0 10px;
       border: 1px solid #ddd;
       position: relative;
       @include flex(space-between);
       @include text-overflow();
       /deep/ .el-input__inner{
         border: 0;
       }
     }
     .btn{
         width: 88px;
         height: 48px;
         border-radius: 0 10px 10px 0;
         border: 1px solid #ddd;
         border-left: 0;
         @include flex();
         font-size: 14px;
         color: #47B6C7;
       }
   }
   .submit-btn{
     width: 162px;
     height: 44px;
     line-height: 43px;
     background: #47B6C7;
     border-radius: 10px;
     font-size: 16px;
     color: #fff;
     text-align: center;
     margin: 0;
     // margin: 42px auto 30px;
   }
   .jump-btn{
     line-height: 1.4;
     font-size: 16px;
     color: #47B6C7;
     text-align: center;
     display: block;
     margin-left: 12px;
   }
   .footer{
     position: fixed;
     bottom: auto;
   }
 }
 .footer-btns{
   display: flex;
   align-items: center;
   justify-content: center;
 }
 </style>


// WEBPACK FOOTER //
// src/views/register-mp.vue